// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1k_R7","title":"ClientCherryInfo_title__38ygD","itemText":"ClientCherryInfo_itemText__1Hhso"};